export default {
    corporations (state) {
      return state.corporations
    },
  subscribers (state) {
    return state.subscribers
  },
    selectedCorporation (state) {
        return state.selectedCorporation
    },

    getCorporation: state => (id) => {
      return state.corporations.find(item => item.corporationId == id)
    }
}



// WEBPACK FOOTER //
// ./src/store/modules/corporations/getters.js